import {Field, formValueSelector, reduxForm} from "redux-form";
import {Button, Col, Modal, ModalBody, ModalHeader, Row} from "reactstrap";
import TextFieldMaterial from "../../../../shared/components/material_field/TextFieldMaterial";
import React from "react";
import {connect} from "react-redux";
import {editLevel} from "../../../../redux/services/projects";


const requiredFieldEditBlock = (value) => (value ? undefined : "You must enter a value");

let EditLevelProjectForm = ({modalEditLevel, toggleEditModal, id, name}) => {

    const handleSubmit = (event) => {
        editLevel({
            id,
            name,
        });
    }

    return (<div className="centered">
        <Modal
            isOpen={modalEditLevel}
            toggle={toggleEditModal}
            modalClassName={`ltr-support`}
            className={`modal-dialog--primary locum-preview-modal createBlockModal`}
        >
            <ModalHeader className="modal-header">
                <div>
                    <h3>Edit block</h3>
                </div>
                <button
                    className="lnr lnr-cross modal__close-btn"
                    type="button"
                    onClick={() => {
                        toggleEditModal();
                    }}
                />
            </ModalHeader>
            <ModalBody className="createBlockModalBody">
                <form
                    id={"edit_level_project_form"}
                    onSubmit={(event) => {
                        handleSubmit(event);
                        event.preventDefault();

                        if (
                            name.length
                        ) {
                            toggleEditModal();
                        }
                    }}
                >

                    <Row md={12} className="mt-2">
                        <Field
                            name="name"
                            component={TextFieldMaterial}
                            placeholder="Enter level name"
                            type={"text"}
                            validate={[requiredFieldEditBlock]}
                        />
                    </Row>

                    <Row md={12} className="mt-4">
                        <Field name="id"
                               component={"input"}
                               type={"hidden"}/>
                    </Row>

                    <Row md={12} className="mt-4 justify-content-end">
                        <Row md={12} className="justify-content-end">
                            <Col md={5}>
                                <Button
                                    className="cancelButton"
                                    onClick={() => {
                                        toggleEditModal();
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Col>

                            <Col md={5}>
                                <Button
                                    className="button"
                                    type={"submit"}
                                    form={"edit_level_project_form"}
                                >
                                    Confirm
                                </Button>
                            </Col>
                        </Row>
                    </Row>
                </form>
            </ModalBody>
        </Modal>
    </div>)
}

EditLevelProjectForm =  reduxForm({
    form: "edit_level_project_form",
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
    touchOnChange: true,
})(EditLevelProjectForm);

const selector = formValueSelector('edit_level_project_form');
EditLevelProjectForm = connect(state => {
    return selector(state, 'id', 'name');
})(EditLevelProjectForm)

export default  EditLevelProjectForm;